export type LanderV2TrustpilotReview = {
  reviewer: string;
  dateLabel: string;
  title: string;
  content: string;
  initials: string;
  avatarTextColor: string;
  avatarBackgroundColor: string;
};

export const landerV2TrustpilotReviews: LanderV2TrustpilotReview[] = [
  {
    reviewer: "Gary Hatch",
    dateLabel: "6 days ago",
    title: "Fantastic service from beginning to end...",
    content: "Fantastic service from beginning to end looked after all the way through and great advice. Recommended.",
    initials: "GH",
    avatarTextColor: "rgb(15, 81, 50)",
    avatarBackgroundColor: "rgb(220, 237, 225)",
  },
  {
    reviewer: "Karen Sanderson",
    dateLabel: "6 weeks ago",
    title: "Outstanding services",
    content:
      "Outstanding services. Bespoke financial accommodation, precise. James and Callum were exceptional in catering for my needs.",
    initials: "KS",
    avatarTextColor: "rgb(76, 29, 149)",
    avatarBackgroundColor: "rgb(232, 222, 255)",
  },
  {
    reviewer: "RSharp",
    dateLabel: "2 weeks ago",
    title: "Straight forward process",
    content: "Straight forward process, excellent customer service and very competitive pricing. Highly recommended.",
    initials: "RS",
    avatarTextColor: "rgb(122, 79, 0)",
    avatarBackgroundColor: "rgb(255, 244, 217)",
  },
  {
    reviewer: "Miss Debbie Lewis",
    dateLabel: "3 weeks ago",
    title: "Very helpful staff informing me of my options",
    content:
      "Very helpful staff informing me of my options all the way. Received regular updates on progress and all in all would not have been able to do this without your help.",
    initials: "DL",
    avatarTextColor: "rgb(7, 89, 133)",
    avatarBackgroundColor: "rgb(219, 240, 255)",
  },
];
